import React, { useEffect, useRef, useState } from 'react'
import ModalCustom from '../../../modal-custom'
import { Button, Card, Form, Image, Row, Table } from 'react-bootstrap'
import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from 'yup'
import { Controller, useForm } from 'react-hook-form'
import moment from 'moment'
import Bin from '../../../../images/bin.svg'
import { v4 as uuidv4 } from 'uuid'
import { useDebounce } from '@react-hook/debounce'
import Autocomplete from '../../../custom/autocomplete'
import UseOrganization from '../../../../hooks/use-org'
import Error_500 from '../../../error/error-500'
import { createEjipRoundAPI } from '../../../../services/ejip'
import Error_false from '../../../error/error-false'
import SwalCustom from '../../../../alert/swal-custom'
import { TXTSUCCESS } from '../../../../Constants'
import CustomAutocomplete from '../../../CustomAutocomplete'
import UseEmpsNameEjip from '../../../../hooks/use-emps-name-ejip'
import { BsPlusLg } from 'react-icons/bs'
// import CustomDatePicker from '../../../datepicker-custiom-lock'
import useNumberInput from '../../../../helper/input-fix-num'
import CustomDatePicker from '../../../custom/CustomDatePicker'
const schema = yup
  .object({
    roundName: yup.string().required('This is a required question'),
    openDate: yup.string().required('This is a required question'),
    endDate: yup.string().required('This is a required question')
  })
  .required()
export default function ModalCreateRound({
  isModalOpen,
  handleCancel,
  fnData,
  fundId,
  setIsModalOpenAddMember
}) {
  const [percentage, setPercentage] = useState('')

  const [member, setMember] = useState([])
  const [memberId, setMemberId] = useState()
  const [org, setOrg] = useState()
  const [isSave, setIsSave] = useState(false)
  const [keyName, setKeyName] = useDebounce('', 1000)
  const dataOrgs = UseOrganization()
  const empName = UseEmpsNameEjip(org?.value, keyName, fundId)
  const [endDate, setEndDate] = useState(null)
  const [startDate, setStartDate] = useState(null)
  const inputRef = useRef(null)
  const handleKeyDownNum = useNumberInput(inputRef)

  const {
    control,
    setValue,
    setError,
    handleSubmit,
    formState: { errors }
  } = useForm({
    resolver: yupResolver(schema)
  })
  useEffect(() => {
    if (dataOrgs.length > 0) {
      setOrg(dataOrgs[0])
    }
  }, [dataOrgs])

  useEffect(() => {
    setEndDate(null)
    setValue('roundName', '')
    setValue('openDate', '')
    setValue('endDate', '')
  }, [isModalOpen])

  const onSubmitEdit = async (d) => {
    try {
      setIsSave(true)
      const body = {
        fundId,
        round: d.roundName,
        openDate: d.openDate ? moment(d.openDate).format('YYYY-MM-DD') : '',
        endDate: d.endDate ? moment(d.endDate).format('YYYY-MM-DD') : '',
        member
      }
      const resp = await createEjipRoundAPI(body)
      setIsSave(false)
      if (!resp) return
      if (resp.status) {
        handleCancel()
        const body = {
          page: 1,
          size: 20,
          fundId
        }
        SwalCustom({
          title: 'Success!',
          text: TXTSUCCESS,
          timer: 1500,
          showConfirmButton: false
        })
        fnData(body)
      } else {
        Error_false(resp)
      }
    } catch (error) {
      Error_500(error)
    }
  }

  const onSubmitField = async () => {
    const newMember = { ...memberId, id: uuidv4(), per: percentage }
    setMember((prevMembers) => [...prevMembers, newMember])

    setPercentage(false)
    setMemberId('')
  }
  const onDeleteField = (id) => {
    setMember((prev) => {
      return prev.filter((item) => item.id !== id)
    })
  }

  return (
    <ModalCustom
      open={isModalOpen}
      width={1000}
      centered
      onCancel={handleCancel}
    >
      <div>
        <h5 className="text-primary ">Add Periods</h5>
      </div>
      <Form onSubmit={handleSubmit(onSubmitEdit)}>
        <div className="row border-top">
          <div className="col-xl-4 p-xl-3 border-end">
            <div> Round </div>

            <Controller
              name={'roundName'}
              control={control}
              render={({ field: { value = '', onChange } }) => (
                <Form.Control value={value} onChange={onChange} />
              )}
            />
            {errors.roundName?.message && (
              <label className="small text-danger">
                {errors.roundName.message}
              </label>
            )}
            <div className="mt-3">
              <div> Fund Opening Date</div>

              <Controller
                name={'openDate'}
                control={control}
                render={({ field: { value = '', onChange } }) => (
                  <div className="w-100">
                    <CustomDatePicker
                      dateFormat="dd/MM/yyyy"
                      maxDate={endDate ? new Date(endDate) : null}
                      className="w-100"
                      id="picker-date-month-btn"
                      value={value}
                      onChange={(date) => {
                        onChange(date)
                        setStartDate(date)
                        setError('openDate', date)
                      }}
                    />
                  </div>
                )}
              />
              {errors.openDate?.message && (
                <label className="small text-danger">
                  {errors.openDate.message}
                </label>
              )}
            </div>

            <div className="mt-3 ">
              <div className=""> Fund End Date </div>
              <Controller
                name={'endDate'}
                control={control}
                render={({ field: { value = '', onChange } }) => (
                  <CustomDatePicker
                    dateFormat="dd/MM/yyyy"
                    id="picker-date-month-btn"
                    value={value}
                    minDate={startDate}
                    onChange={(date) => {
                      onChange(date)
                      setEndDate(date)
                      setError('endDate', date)
                    }}
                    className="w-100"
                  />
                )}
              />
              {errors.endDate?.message && (
                <label className="small text-danger">
                  {errors.endDate.message}
                </label>
              )}
            </div>
          </div>
          <div className="col-xl-8 p-xl-3">
            <div className="">
              Add Member <span className="text-primary">{member.length}</span>{' '}
              Peoples
            </div>
            <Row>
              <div className="d-flex justify-content-between">
                <div
                  className="align-self-end d-grid"
                  style={{ minWidth: 120 }}
                >
                  <Autocomplete
                    options={dataOrgs}
                    value={org}
                    onChange={(data) => setOrg(data)}
                  />
                </div>
                <div style={{ minWidth: 330 }}>
                  <CustomAutocomplete
                    placeholder="Name/ Code"
                    options={empName}
                    value={memberId}
                    onChange={(data) => {
                      setMemberId(data)
                    }}
                    onInputChange={(data) => {
                      setKeyName(data ? data.toUpperCase() : '')
                    }}
                    freeSolo={false}
                  />
                </div>
                <div
                  className="align-self-end d-grid"
                  style={{ minWidth: 80, maxWidth: 80 }}
                >
                  <Form.Control
                    type="number"
                    placeholder="%"
                    onKeyDown={handleKeyDownNum}
                    value={percentage}
                    onChange={(e) => setPercentage(e.target.value)}
                  />
                </div>

                <div className="align-self-end d-grid">
                  <Button
                    disabled={!percentage || !memberId}
                    className="rounded-3"
                    onClick={onSubmitField}
                    size="sm"
                    style={{ minWidth: 80, maxWidth: 80 }}
                  >
                    <BsPlusLg /> Add
                  </Button>
                </div>
              </div>

              <div className=" col-12 mt-4 overflow-auto">
                <Card.Body style={{ height: '300px' }}>
                  <Table hover responsive>
                    <tbody>
                      {member.length > 0 ? (
                        member.map((m, i) => (
                          <tr key={i}>
                            <td className="">{m.code}</td>
                            <td className="">{m.fullname}</td>
                            <td className="">{m.per}%</td>
                            <td className="text-center">
                              <Image
                                src={Bin}
                                onClick={() => onDeleteField(m.id)}
                              />
                            </td>
                          </tr>
                        ))
                      ) : (
                        <div className="text-center">- No Data -</div>
                      )}
                    </tbody>
                  </Table>
                </Card.Body>
              </div>
            </Row>
          </div>
        </div>

        <div className="col-12 mt-5 mb-3 d-flex gap-3 justify-content-center">
          <Button
            variant="outline-primary rounded-3"
            style={{
              width: '130px'
            }}
            size="sm"
            type="submit"
            onClick={handleCancel}
            className="rounded-3"
          >
            Cancel
          </Button>

          <Button
            disabled={isSave}
            className="btn btn-primary rounded-3"
            type="submit"
            style={{
              width: '130px'
            }}
            size="sm"
          >
            {isSave ? 'Apply...' : 'Apply'}
          </Button>
        </div>
      </Form>
    </ModalCustom>
  )
}
